import { createContext, useContext } from 'react';
import {
  type AutomationOrFolder,
  type Folder,
} from 'store/automationsPage/automations.redux';
import { type FolderStruct } from '@kizen/kds/FoldersTree';

export const FoldersDragAndDropContext = createContext<{
  dragging: boolean;
  patching: boolean;
  isAllowed: boolean;
  dragItem: AutomationOrFolder | null;
  dropFolder: FolderStruct<Folder> | null;
  onDragStart: () => void;
  onDragEnd: () => void;
  onHoverIn: (item: AutomationOrFolder) => void;
  onHoverOut: () => void;
  onHoverInDropZone: (folderStructure: FolderStruct<Folder>) => void;
  onHoverOutDropZone: () => void;
}>({
  dragging: false,
  patching: false,
  isAllowed: false,
  dragItem: null,
  dropFolder: null,
  onDragStart: () => {},
  onDragEnd: () => {},
  onHoverIn: () => {},
  onHoverOut: () => {},
  onHoverInDropZone: () => {},
  onHoverOutDropZone: () => {},
});

export const useDragAndDropContext = () => {
  const context = useContext(FoldersDragAndDropContext);
  if (!context) {
    throw new Error(
      'useDragAndDropContext must be used within a FoldersDragAndDropProvider'
    );
  }
  return context;
};
